import React from 'react';
import styled from 'styled-components';
import { greyDark } from '~theme';

const StyledHr = styled.hr`
  border-top: 1px solid ${greyDark};
`;

const HorizontalRule = () => <StyledHr />;

export default HorizontalRule;
